import React, { forwardRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full space-y-1.5" data-id="element-985">
        <label className="block text-sm font-medium text-gray-700" data-id="element-986">
          {label} {props.required && <span className="text-rose-500" data-id="element-987">*</span>}
        </label>
        <div className="relative" data-id="element-988">
          <input ref={ref} className={`
              w-full px-4 py-2.5 rounded-xl border bg-white text-gray-900 placeholder-gray-400
              transition-all duration-200 ease-in-out
              focus:outline-none focus:ring-2 focus:ring-offset-0
              disabled:opacity-50 disabled:cursor-not-allowed
              ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : 'border-gray-200 focus:border-rose-500 focus:ring-rose-200 hover:border-rose-300'}
              ${className}
            `} {...props} data-id="element-989" />
        </div>
        <AnimatePresence mode="wait" data-id="element-990">
          {error && <motion.p initial={{
        opacity: 0,
        y: -5
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -5
      }} className="text-sm text-red-500 font-medium" data-id="element-991">
              {error}
            </motion.p>}
        </AnimatePresence>
      </div>;
});
Input.displayName = 'Input';